<template>
	<f7-page name="ccm-study-plan-week" class="page-bg-render">
		<f7-navbar>
			<f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <div class="title">
				학습 플래너 
      </div>
			<f7-nav-right>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="right"></f7-link>
      </f7-nav-right>
    </f7-navbar>  
		<div class="block">
			<div class="block-title-medium text-align-center">	
				<span class="margin-left padding-left">
					<a href="#" class="item-link" v-if="weekNo > 1" v-on:click="prevWeek()">◀</a> 
						{{weekNo}} 주차					
					<a href="#" class="item-link" v-if="weekStudyCntInfo.maxWeeks > weekNo" v-on:click="nextWeek()">▶</a>
				</span>
				<a href="#" class="link float-right" v-on:click="studyPlanMonthPage();">월간학습</a>	
			</div>		
		</div>
		<div class="block row text-align-center">
			<div class="col-33">지난주 차시 미학습: {{weekStudyCntInfo.prevWeekCnt}} / {{weekStudyCntInfo.timesPerWeek}}</div>
			<div class="col-33">이번주 차시 진행사항: {{weekStudyCntInfo.thisWeekCnt}} / {{weekStudyCntInfo.timesPerWeek}}</div>
			<div class="col-33">총 학습 차시: {{weekStudyCntInfo.totalStudyCnt}} / {{weekStudyCntInfo.totalTimes}}</div>
		</div>
		<div class="list simple-list no-hairlines">
			<ul>
				<li>
					<div class="week-graph">					
    				<div class="week-bar"  v-bind:style="{width:getweekTimesResult()}"></div>			
						<div class="week-bar-title">이번주 차시({{getweekTimesResult()}})</div>					
					</div>
				</li>
				<li>
					<div class="week-graph">					
    				<div class="week-bar" v-bind:style="{width:getTotalStudyResult()}"></div>			
						<div class="week-bar-title">총학습({{getTotalStudyResult()}})</div>					
					</div>
				</li>
				
  		</ul>
		</div>
		<hr/>

		<div class="list">
			<ul>
				<template v-for="(item, i) in weekStudyResultArray">
					<li :key="'ii'+i">
						<div class="item-content">
							<div class="item-inner">						
								<div class="week-time-graph">		
									<span v-bind:class="[weekTimeBar, getStudyResult(item, 'review-sdy')]" style="width:33%;">복습</span>
									<span v-bind:class="[weekTimeBar, getStudyResult(item, 'unit-sdy')]" style="width:33%;">학습</span>
									<span v-bind:class="[weekTimeBar, getStudyResult(item, 'clinic-first-sdy')]" style="width:34%;">클리닉</span>								
								</div>																		
							</div>					
						</div>
						<p class="text-align-center no-margin-top">
							<a href="#" class="link" v-on:click="studyPlanDaypage(item);">{{item.TIMES_NO}}차시 </a>
						</p>
					</li>
				</template>
			</ul>			
		</div>
	</f7-page>
</template>

<script>
import { f7 } from 'framework7-vue';
import MODULE from '../../../js/common/module';
import Vue from 'vue';
import PAGES from '../../../js/pages';
import AUTH from '../../../js/common/auth.js'
import CONST from '../../../js/common/constant';
import API from '../../../js/common/api';

export default {
	data() {
		return {	
			plannerKey : 0,
			weekNo : 0,
			groupKey : 0,
			gradeId : "",
			semesterId : "",
			reviseId : "",
			weekStudyCntInfo : {
				startDate : "",
				endDate : "",
				totalTimes : 0,
				totalStudyCnt :  0,
				thisWeekCnt : 0,
				prevWeekCnt : 0,
				timesPerWeek : 0,
				maxWeeks : 0
			},
			weekStudyResultArray : [],		
			weekTimeBar : "week-time-bar",		
		}
	},
	mounted() {
		const _this = this;
		_this.plannerKey = _this.$f7route.context.plannerKey;
		_this.weekNo = _this.$f7route.context.weekNo;
		_this.groupKey = _this.$f7route.context.groupKey;
		_this.gradeId = _this.$f7route.context.gradeId;
		_this.semesterId = _this.$f7route.context.semesterId;
		_this.reviseId = _this.$f7route.context.reviseId;
		
		_this.loadStudyPlanWeek();
		$(document).on('page:reinit', '.page[data-name="ccm-study-plan-week"]', _this.loadStudyPlanWeek);
	},	
	methods: {

		loadStudyPlanWeek() {
			const _this = this;

			let param = {
				plannerKey : _this.plannerKey,
				weekNo : _this.weekNo,
				groupKey : _this.groupKey,
				gradeId : _this.gradeId,
				reviseId : _this.reviseId,
				semesterId : _this.semesterId
			};

			API.ajaxRequest({
				url: API.getStudyPlanWeekUrl(),
				data: param
			}).then(function (data) {
				
				_this.weekStudyCntInfo.startDate = _this.displayDateTime(data.weekStudyCntInfo.START_DATE);
				_this.weekStudyCntInfo.endDate = _this.displayDateTime(data.weekStudyCntInfo.END_DATE);
				_this.weekStudyCntInfo.totalTimes = data.weekStudyCntInfo.TOTAL_TIMES;
				_this.weekStudyCntInfo.totalStudyCnt = data.weekStudyCntInfo.TOTAL_STUDY_CNT;
				_this.weekStudyCntInfo.thisWeekCnt = data.weekStudyCntInfo.THIS_WEEK_CNT;				
				_this.weekStudyCntInfo.timesPerWeek = data.weekStudyCntInfo.TIMES_PER_WEEK;
				_this.weekStudyCntInfo.maxWeeks = data.weekStudyCntInfo.MAX_WEEK;
				_this.weekStudyCntInfo.prevWeekCnt = data.weekStudyCntInfo.TIMES_PER_WEEK - data.weekStudyCntInfo.PREV_WEEK_CNT;
				_this.weekStudyResultArray = data.weekStudyResultArray;
			}).catch(function (code) {
				MODULE.UITool.catchBlock(code, PAGES, AUTH);
			});

		},
		getweekTimesResult() {
			const _this = this;
			var percentResult = 0;

			try {
				
				percentResult = (_this.weekStudyCntInfo.thisWeekCnt * 100) /  _this.weekStudyCntInfo.timesPerWeek;							
				percentResult = Math.round(percentResult);
				percentResult = MODULE.Util.number(percentResult);				
				percentResult = percentResult + "%";

			} catch (e) {

			}		
			return percentResult;
		},
		getTotalStudyResult() {
			const _this = this;
			var percentResult = 0;

			try {
				
				percentResult = (_this.weekStudyCntInfo.totalStudyCnt * 100) /  _this.weekStudyCntInfo.totalTimes;							
				percentResult = Math.round(percentResult);
				percentResult = MODULE.Util.number(percentResult);		
				percentResult = percentResult + "%";

			} catch (e) {

			}		
			return percentResult;

		},
		getStudyResult(item, studySteId) {
			const _this = this;
		
			var classStatus = "none-study";
			
			if(studySteId == CONST.studyStepType["review-sdy"].id) {

				if(item.RESTUDY_TYPES != 'none') {
					
					if (item.REVIEW_SDY == 1 && item.TIMES_NO > 1) {
						classStatus = "complete";
					} 

				} else {
					classStatus ="none-study";
				}

			} else if(studySteId == CONST.studyStepType["unit-sdy"].id) {
					
					if (item.UNIT_SDY == 1) {
						classStatus = "complete";
					} 

			} else { // 클리닉 은 1차 가 있다면 2차도 검사

				if(item.CLINIC1_TYPE != "none")	{									

					if(item.CLINIC_FIRST_SDY == 1) {
						
						classStatus = "complete";
						
						if(item.CLINIC2_TYPE != "none") {

							if(item.CLINIC_SECOND_SDY == 1) {
								classStatus = "complete";
							} else {
								classStatus = "studying";
							}
								
						}
					} 				
				} else{
					classStatus ="none-study";
				}

			}
			
			return classStatus;
		},
		displayDateTime(dateTime) {
			var formatDate = moment(dateTime).format("MM.DD");			
			return formatDate;
		},	
		prevWeek() {
			const _this = this;
			
			if(_this.weekNo > 1) {
				_this.weekNo -= 1;				
				_this.loadStudyPlanWeek();
			}

		},
		nextWeek() {
			const _this = this;
			if(_this.weekStudyCntInfo.maxWeeks > _this.weekNo) {
				_this.weekNo += 1;				
				_this.loadStudyPlanWeek();
			}
		},
		studyPlanDaypage(item) {
			const _this = this;
			var url = PAGES.MENU_CCM_STUDY_PLAN_DAY;

			var param = {
				plannerKey : _this.plannerKey,				
				timesNo : item.TIMES_NO,
				groupKey : _this.groupKey,
				gradeId : _this.gradeId,
				reviseId : _this.reviseId,
				semesterId : _this.semesterId	  			
			};
			
			PAGES.goPage(url,param);
			
		},
		studyPlanMonthPage() {
			const _this = this;
			var url = PAGES.MENU_CCM_STUDY_PLAN_MONTH;

			var param = {
				plannerKey : _this.plannerKey,
				weekNo : _this.weekNo,
				groupKey : _this.groupKey,
				gradeId : _this.gradeId,
				reviseId : _this.reviseId,
				semesterId : _this.semesterId
			};  
			
			PAGES.goPage(url,param);
		}		
	}
}
</script>